import { http } from '@/api/http'
import type {
  ApiOrderDetails,
  ApiOrderListItem,
  ApiPayType,
  ApiSystemSettings,
  CreateOrderPayload,
  CreateOrderResponse,
  RatingPayload,
} from '@/api/types/order'

/** За раз забираем последние 50 заказов — пагинации в макете нет. */
const ORDERS_TAKE = 50

/** Настройки бренда и справочник способов оплаты — нужны на оформлении заказа. */
export const systemService = {
  settings: () => http.get<ApiSystemSettings>('/system/'),
  payTypes: () => http.get<ApiPayType[]>('/paytypes/List'),
}

export const orderService = {
  create: (payload: CreateOrderPayload) =>
    http.post<CreateOrderResponse>('/delivery/Create', payload),
  list: (customerId: string) =>
    http.get<ApiOrderListItem[]>('/delivery/List', { customerId, skip: 0, take: ORDERS_TAKE }),
  get: (orderId: string) => http.get<ApiOrderDetails>('/delivery/Get', { orderId }),
  rate: (body: RatingPayload) => http.post<unknown>('/delivery/Rating', body),
}
